// LuxuryPage.jsx
import React from "react";
// import "./LuxuryPage.css";
import "../App.css";
import { useEnquiryModal } from "./EnquiryModal";
// import { FaLocationDot } from "react-icons/fa6";
import { ENQUIRY_CTA } from "../constants";

const LuxuryPage = () => {
  const { openModal } = useEnquiryModal();
  return (
    <div id="about" className="luxury-page">
      {/* ----------- Section 1: Luxury Launch ----------- */}
      <section className="luxury-section">
        <div className="luxury-image">
          <img
            src="../Assets/banner2.png"
            alt="Luxury View"
          />
        </div>
        <div className="luxury-text">
          <h2 className="font-semibold">
            SHAHRUKHZ RESIDENCES BY DANUBE
          </h2>
          {/* <div className="luxury-location flex items-center">
            <FaLocationDot className="text-[#997736] mr-2" />
            <span className="text-[#997736] font-bold text-lg">Emirates Road, Sharjah</span>
          </div> */}
          <p>
            Shahrukhz Residences by Danube Properties is a new waterfront landmark in Dubai Maritime City, created with Shah Rukh Khan. Every apartment is delivered fully furnished, with open views of the sea. Choose from studios, one, two and three bedroom apartments, or penthouses designed by Gauri Khan, with more than 40 amenities for wellness, fitness and family life. 
          </p>
          <button onClick={() => openModal(ENQUIRY_CTA.INTRO)} className="mt-4 font-semibold border-2 rounded-md border-[#997736] text-[#997736] hover:text-white px-6 py-2 hover:bg-[#997736] transition">DOWNLOAD BROCHURE</button>
        </div>
      </section>
    </div>
  );
};

export default LuxuryPage;
